<template>
  <el-container direction="vertical">
    <!-- 查询条件 -->
    <el-row style="height: 40px; line-height: 35px; border-radius: 4px; border: 1px solid #ccc; margin: 10px;" :gutter="10">
      <el-col :span="3">
        <el-input v-model="search.userName" placeholder="请输入姓名" clearable @keyup.enter.native="query"></el-input>
      </el-col>
      <el-col :span="3">
        <el-input v-model="search.mobile" placeholder="请输入手机号码" clearable @keyup.enter.native="query"></el-input>
      </el-col>
      <el-col v-if="!isBj" :span="3">
        <el-select v-model="search.province" placeholder="请选择省份" style="width: 100%" clearable @keyup.enter.native="query">
          <el-option value="" label="请选择"></el-option>
          <el-option v-for="(item, index) in globalData.provinceOptions" :key="index" :value="item.value" :label="item.text"></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-input v-model="search.city" placeholder="请输入城市名称" clearable @keyup.enter.native="query"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="search.school" placeholder="请输入学校名称" clearable @keyup.enter.native="query"></el-input>
      </el-col>
      <el-col :span="3">
        <el-select v-model="search.nominate" placeholder="请选择提交状态" style="width: 100%" clearable @keyup.enter.native="query">
          <el-option value="" label="请选择"></el-option>
          <el-option value="1" label="已提交"></el-option>
          <el-option value="0" label="未提交"></el-option>
        </el-select>
      </el-col>
      
      <el-col :span="4">
        <el-button type="primary" icon="el-icon-search" @click="query">查询</el-button>
        <json-excel v-if="hasRole" :data="exportData" name='团体账号注册名单.xls' :beforeGenerate="beforeExport" :fields='exportFields' style='display:inline-block;margin:0 10px'>
          <el-button type="warning" icon="el-icon-download">导出</el-button>
        </json-excel>
      </el-col>
    </el-row>

    <!-- 数据展示 -->
    <el-row style="flex: 1; background: #ccc; margin: 0 10px;display:flex">
      <el-table :data="page.list" height="100%"  border style="width: 100%;" v-loading="loading">
        
        <el-table-column prop="id" label="ID" width="50"></el-table-column>
        <el-table-column prop="userName" label="姓名" width="75"></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="100"></el-table-column>
        <el-table-column prop="province" label="省份" width="95"></el-table-column>
        <el-table-column prop="city" label="城市" width="100"></el-table-column>
        <el-table-column prop="school" label="学校" width="230"></el-table-column>
        <el-table-column prop="workCount" label="提交作品数" width="85" align="center"></el-table-column>
        <el-table-column prop="judgeCount" label="评审人数" width="70" align="center"></el-table-column>
        <el-table-column prop="studentCount" label="推荐人数" width="70" align="center"></el-table-column>
        <el-table-column prop="isNominate" label="提交状态" width="70"></el-table-column>
        <el-table-column prop="remark" label="推荐评语" show-overflow-tooltip ></el-table-column>
        <el-table-column label="申请书" width="100">
          <template slot-scope="sc">
            <el-button type="text" @click="viewBook(sc.row.applyBook)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewStudentList(scope.row)" >查看推荐名单</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    
    <!-- 分页 -->
    <el-row style="border: 1px solid #aaa; box-sizing: border-box; background: #e1e1e1; margin: 0 10px 10px 10px; text-align: center;">
      <el-pagination background layout="prev, pager, next,total" :current-page="search.pageNum" :page-size="20" :total="page.total" @current-change="pageChange"></el-pagination>
    </el-row>

    <el-dialog title="查看申请书" :visible.sync="dialogVisible" width="700px">
      <img :src="applyBookUrl" alt="" style="width:657px">
    </el-dialog>

  </el-container>  
</template>

<script>
let that 
export default {
  computed: {
    hasRole() {
      let manager = this.globalData.manager
      let roles = this.globalData.exportRole
      return roles.includes(manager.id)
    },
    isBj(){
      let manager = JSON.parse(sessionStorage.getItem("manager"))
      let roles = this.globalData.bj
      return roles.includes(manager.id)
    }
  },
  data() {
    return {
      page: {},
      applyBookUrl: '',
      dialogVisible: false,
      tableHeight: '300px',
      search: {
        pageNum: 1
      },
      exportFields: {
        'ID':'id',
        '姓名':'userName',
        '手机号':'mobile',
        '省份':'province',
        '城市':'city',
        '区县':'county',
        '学校':'school',
        '参赛申请书':'applyBookStatus',
        '审核状态':'applyType',
        '报名人数':'studentCount',
        '作品提交数':'workCount'
      },
      exportData:[],
      loading:true
    }
  },
  methods: {
    // 分页显示数据
    pageChange(n) {
      this.loading = true
      this.loadData(n)
    },

    // 数据查询
    query() {
      this.loading = true
      this.loadData(1)
    },

    // 查看申请书
    viewBook(url){
      this.applyBookUrl = ""
      this.applyBookUrl = url
      this.dialogVisible = true
    },

    // 导出数据
    async beforeExport() {
      await this.api.teacher.queryList(this.search).then(res => {
        this.exportData = res.data
      })
    },

    // 查看推荐学生名单
    viewStudentList(row){
      if(row.studentCount != "0"){
        this.api.teacher.findSubmitStudents(`id=${row.id}`).then(res => {
          that.globalData.nominateStudents = res.data
          that.globalData.remark = row.remark
          that.$dialog.nominateStudentList()
        })
      }else{
        this.$message({
          message: '此团体老师还未提交推荐名单！',
          type: 'warning'
        });
      }
    },

    isBjRole(){
      let manager = JSON.parse(sessionStorage.getItem("manager"))
      let roles = this.globalData.bj
      return roles.includes(manager.id)
    },

    // 加载数据
    loadData(n) {
      if(this.isBjRole()) {
       this.search.province = '北京市' 
      }

      this.search.pageNum = n
      if(Object.keys(this.search).length > 0) {
        this.search.pageNum = n
        this.api.teacher.query(this.search).then(res => {
          this.page = res.data
          this.loading = false
        })
      }else {
        this.api.teacher.findPage(`pageNum=${n}`).then(res => {
          this.page = res.data
          this.loading = false
        })
      }      
    }
  },
  mounted() {
    that = this
    this.loadData(1)
  }
}
</script>